module.exports = __webpack_public_path__ + "img/goods2_bg.4dfc3409.png";